import { useMutation } from '@tanstack/react-query';

import {
  profilesControllerUpdate,
  type UpdateProfileDto,
} from '@/api/core-api';
import { getClient } from '@/utils/get-api-client';
import { ERROR_CODES, readErrorCode } from '@common/utils';

/** The new account email is on core-api's blocked-domain list (e.g. duck.com). */
export class EmailDomainNotAllowedError extends Error {
  constructor() {
    super('Email domain not allowed');
    this.name = 'EmailDomainNotAllowedError';
  }
}

export function useUpdateProfile() {
  return useMutation({
    mutationFn: async ({
      profileId,
      userId,
      updateProfileDto,
    }: {
      profileId: string;
      userId: string;
      updateProfileDto: UpdateProfileDto;
    }) => {
      const client = getClient(userId);
      const response = await profilesControllerUpdate({
        path: { profileId },
        client,
        body: updateProfileDto,
      });

      if (response.error) {
        if (
          readErrorCode(response.error) === ERROR_CODES.EMAIL_DOMAIN_NOT_ALLOWED
        ) {
          throw new EmailDomainNotAllowedError();
        }
        throw new Error('Failed to update profile');
      }

      return { profileId, userId };
    },
  });
}
